module.exports = __webpack_public_path__ + "static/media/ic_首页_pr.bdc92b1d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_首页_pr.svg
// module id = 190
// module chunks = 0